import { render } from "./PigsBatchesModal.vue?vue&type=template&id=6c4496d3&ts=true"
import script from "./PigsBatchesModal.vue?vue&type=script&lang=ts"
export * from "./PigsBatchesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__